import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { LoggingService } from '../utils/logging.service';
import { HttpActiveRequestService } from './http-active-request.service';

/**
 * Dieser Interceptor wird benötigt um den Fortschritt von Fileuploads
 * (z.B. {@link FileUploadComponent} zu erfahren. Gibt den Status kontinuierlich an den
 * {@link HttpActiveRequestService} weiter.
 */
@Injectable()
export class HttpProgressInterceptor implements HttpInterceptor {

    constructor(private httpActiveRequestService: HttpActiveRequestService,
                private loggingService: LoggingService) {
    }

    intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<any>> {
        const reportingRequest: HttpRequest<T> = req.clone({ reportProgress: true });
        const handle: Observable<HttpEvent<T>> = next.handle(reportingRequest);

        return handle.pipe(
            tap(
                (event: HttpEvent<T>) => {
                    switch (event.type) {
                        case HttpEventType.Sent:
                            this.loggingService.trace('HttpProgressInterceptor.intercept[tap:HttpEventType.Sent]: invoke onStarted()');
                            this.httpActiveRequestService.onStarted(req);
                            break;
                        case HttpEventType.DownloadProgress:
                            this.loggingService.trace(
                                'HttpProgressInterceptor.intercept[tap:HttpEventType.DownloadProgress]: invoke onProgress()'
                            );
                            if (event.total) {
                                this.httpActiveRequestService.onProgress(req, Math.round((event.loaded / event.total) * 100), true);
                            } else {
                                this.httpActiveRequestService.onProgress(req, 50, true);
                            }
                            break;
                        case HttpEventType.UploadProgress:
                            this.loggingService.trace(
                                'HttpProgressInterceptor.intercept[tap:HttpEventType.UploadProgress]: invoke onProgress()'
                            );
                            if (event.total) {
                                this.httpActiveRequestService.onProgress(req, Math.round((event.loaded / event.total) * 100), false);
                            } else {
                                this.httpActiveRequestService.onProgress(req, 50, false);
                            }
                            break;
                        case HttpEventType.Response:
                            this.loggingService.trace(
                                'HttpProgressInterceptor.intercept[tap:HttpEventType.Response]: invoke onFinished()'
                            );
                            this.httpActiveRequestService.onFinished(req);
                            break;
                        // SPP-486: Der Default Fall darf nicht onFinished aufrufen! Das hat den Fehler hier verursacht
                        default:
                            this.loggingService.trace(
                                'HttpProgressInterceptor.intercept[tap:Default]: Http-Event-Type: ' + HttpEventType[event.type]
                            );
                    }
                }
            ),
            // finalize wird benötigt, falls der Request abbricht
            finalize(() => {
                this.loggingService.trace('HttpProgressInterceptor.intercept[finalize]: invoke onFinished()');
                this.httpActiveRequestService.onFinished(req);
            })
        );
    }
}
